<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import { RouterLink, RouterView, useRoute } from 'vue-router';
import { prefetchCompanyContent } from '../company-content';
import { locale, text } from '../i18n';
import { publicUploadUrl } from '../public-url';

const COMPANY_HERO = publicUploadUrl('/uploads/de/dece7dd0f1f8200ed4f4fcce0af75c53f659aef401bbeb0d71348da4185cb637.jpg');
const route = useRoute();

const hero = computed(() => {
  if (route.name === 'factory') {
    return {
      title: text('研发制造', 'R&D and manufacturing'),
      summary: text('从研发验证到生产装配，为每个项目提供稳定、可复核的交付基础。', 'From engineering validation to assembly, every project is built on dependable delivery.'),
      imageAlt: text('研发制造环境', 'R&D and manufacturing environment'),
      modifier: 'portal-page-hero--factory'
    };
  }

  if (route.name === 'quality') {
    return {
      title: text('质量体系', 'Quality system'),
      summary: text('以规范的验证、记录与持续改进支撑可靠交付。', 'Reliable delivery is supported by structured validation, records and continuous improvement.'),
      imageAlt: text('质量管理与认证资料', 'Quality management and certification documents'),
      modifier: 'portal-page-hero--quality'
    };
  }

  return {
    title: text('用技术能力支撑长期可靠的安检运行', 'Engineering for dependable long-term screening operations'),
    summary: text('JWS 是微剂量X光人体安检设备、毫米波人体扫描设备及监所综合信息系统的原创制造商。', 'Focused on body screening imaging, intelligent recognition and operational systems from engineering through delivery.'),
    imageAlt: text('杭州技卫士总部', 'JWS Hangzhou headquarters'),
    modifier: ''
  };
});

function warmCompanyContent() {
  void prefetchCompanyContent(locale.value);
}

onMounted(warmCompanyContent);
watch(locale, warmCompanyContent);
</script>

<template>
  <div class="legacy-pages">
    <section class="portal-page-hero portal-page-hero--company" :class="hero.modifier">
      <img :src="COMPANY_HERO" :alt="hero.imageAlt">
      <div class="container">
        <span class="portal-eyebrow">{{ text('关于我们', 'About JWS') }}</span>
        <h1>{{ hero.title }}</h1>
        <p>{{ hero.summary }}</p>
      </div>
    </section>

    <nav class="portal-subnav" :aria-label="text('关于我们栏目', 'About navigation')">
      <div class="container">
        <RouterLink to="/company/company">{{ text('公司简介', 'Company') }}</RouterLink>
        <RouterLink to="/company/factory">{{ text('研发制造', 'R&D and manufacturing') }}</RouterLink>
        <RouterLink to="/company/quality">{{ text('质量体系', 'Quality') }}</RouterLink>
      </div>
    </nav>

    <RouterView v-slot="{ Component }">
      <KeepAlive include="FactoryView,QualityView">
        <component :is="Component" />
      </KeepAlive>
    </RouterView>
  </div>
</template>
